import Vue from 'vue';
import { AcompanhamentoPlugin } from 'px-business-components';

Vue.use(AcompanhamentoPlugin, {
  messagesApiUrl: process.env.VUE_APP_API_URL_MESSAGES,
});
